/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StompService} from "./stomp.service";
import Configuration from "./Configuration";

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [],
    exports: []

})
export class StompModule {

    static forRoot(configuration : Configuration): ModuleWithProviders<StompModule> {

        return {
            ngModule: StompModule,
            providers: [StompService, {provide : 'config', useValue: configuration}]
        }
    }
}

